var Industry = "Sector";
var Aerospace = "Industria aeroespacial";
var Agriculture = "Agricultura";
var Automotive = "Automotriz";
var Education = "Educación";
var Gaming = "Videojuegos";
var Government = "Gobierno";
var Healthcare = "Sanidad";
var Hospitality = "Hostelería";
var Manufacturing = "Fabricación";
var Mining = "Minería";
var Other = "Otro";
var Retail = "Venta al por menor";
var Telecommunications = "Telecomunicaciones";
var Travel = "Viajes";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "Ordenadores y electrónica",
	"Consumer goods": "Bienes de consumo",
	Education: Education,
	"Financial services": "Servicios financieros",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "Ciencias biológicas",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "Marketing y publicidad",
	"Media & entertainment": "Medios y entretenimiento",
	Mining: Mining,
	"Non-profit organization": "Organizaciones sin fines de lucro",
	"Oil & gas": "Petróleo y gas",
	Other: Other,
	"Power & utilities": "Energía y servicios públicos",
	"Professional services": "Servicios profesionales",
	"Real estate & construction": "Bienes inmuebles y construcción",
	Retail: Retail,
	"Software & internet": "Software e Internet",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "Transporte y logística",
	Travel: Travel,
	"Wholesale & distribution": "Distribución y ventas al por mayor"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
